import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function PopularGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-2">
              热门漫画
            </h2>
            <p className="text-sm text-foreground-500">
              万人追捧的韩漫佳作，不容错过的精彩故事
            </p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium mt-3 md:mt-0 flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic, index) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              coverImage={comic.coverImage}
              category={comic.category}
              rating={comic.rating}
              views={comic.views}
              tags={comic.tags}
              isFirst={index === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
}